import type { ITimeSlot, ITourFormData } from 'Types/aemui/schedule-a-tour/scheduleATour';
import { getWindowsTimeZone } from '@/util/timeSlotAvailability';

export interface IBookingsTokenResponse {
	token_type: string;
	expires_in: number;
	ext_expires_in: number;
	access_token: string;
}

export interface IBookingsServiceResponse {
	value: IBookingsService[];
}

export interface IBookingsService {
	id: string;
	displayName: string;
	staffMemberIds: string[];
	schedulingPolicy: ISchedulingPolicy;
}

interface ISchedulingPolicy {
	timeSlotInterval: string;
	minimumLeadTime: string;
	maximumAdvance: string;
}

export interface IBookingsStaffAvailabilityResponse {
	value: IStaffAvailability[];
}

export interface IStaffAvailability {
	staffId: string;
	availabilityItems: IAvailabilityItem[];
}

interface IAvailabilityItem {
	status: string;
	serviceId: string;
	startDateTime: IBookingTime;
	endDateTime: IBookingTime;
}

interface IBookingTime {
	dateTime: string;
	timeZone: string;
}

export class BookingAppointmentRequest {
	'@odata.type': string;
	startDateTime: BookingAppointmentTime;
	endDateTime: BookingAppointmentTime;
	optOutOfCustomerEmail: boolean;
	serviceId: string;
	staffMemberIds: string[];
	'customers@odata.type': string;
	customers: BookingsAppointee[];

	public constructor(timeSlot: ITimeSlot, formData: ITourFormData) {
		this['@odata.type'] = '#microsoft.graph.bookingAppointment';
		this.startDateTime = new BookingAppointmentTime(timeSlot.startTime, timeSlot.timeZone);
		this.endDateTime = new BookingAppointmentTime(timeSlot.endTime, timeSlot.timeZone);
		this.optOutOfCustomerEmail = false;
		this.serviceId = timeSlot.serviceId;
		this.staffMemberIds = [timeSlot.staffId];
		this['customers@odata.type'] = '#Collection(microsoft.graph.bookingCustomerInformation)';
		this.customers = [new BookingsAppointee(formData)];
	}
}

class BookingsAppointee {
	'@odata.type': string;
	name: string;
	emailAddress: string;
	phone: string;

	public constructor(formData: ITourFormData) {
		this['@odata.type'] = '#microsoft.graph.bookingCustomerInformation';
		this.name = `${formData.firstName.replace(/\s/g, '')} ${formData.lastName}`;
		this.emailAddress = formData.email;
		this.phone = formData.phone.replace(/\D/g, '');
	}
}

class BookingAppointmentTime {
	'@odata.type': string;
	dateTime: string;
	timeZone: string;

	public constructor(dateTime: string, ianaTimeZone: string) {
		this['@odata.type'] = '#microsoft.graph.dateTimeTimeZone';
		this.dateTime = dateTime;
		this.timeZone = getWindowsTimeZone(ianaTimeZone);
	}
}
